import { Col } from 'reactstrap';
import React from 'react';
import { PropTypes } from 'prop-types';

const FormSection = ({ title, children, sm = 12, md = 6, lg = 4 }) => (
  <Col sm={sm} md={md} lg={lg}>
    <h5>{title}</h5>
    {children}
  </Col>
);

FormSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  sm: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number,
};

export { FormSection };
